import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader,
  MenuItem
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from "react-alert";
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import { LoadingComponent } from 'src/utils/newLoader';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker } from "@material-ui/pickers";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
}));

const screenCode = 'AMENDEDLEAFDETAILSREPORT';

export default function AmendedLeafDetailsReport(props) {
  const [title, setTitle] = useState("Amended Leaf Details Report");
  const classes = useStyles();
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routeList, setRouteList] = useState();
  const [amendedLeafDetails, setAmendedLeafDetails] = useState([]);
  const [cropSupplyInput, setCropSupplyInput] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    registrationNumber: ''
  });
  const [cropSupplyDetails, setCropSupplyDetails] = useState([]);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    routeName: '',
    fromDate: '',
    toDate: ''
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const navigate = useNavigate();
  const alert = useAlert();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [fromDate, setfromDate] = useState(new Date());
  const [toDate, settoDate] = useState(new Date());
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const [csvHeaders, SetCsvHeaders] = useState([])
  const componentRef = useRef();
  const [amendedLeafTotal, setAmendedLeafTotal] = useState({
    totalOriginalWeight: 0,
    totalAmendedWeight: 0,
  });
  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    trackPromise(
      getPermission());
    trackPromise(
      getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropdown());
  }, [cropSupplyInput.groupID]);

  useEffect(() => {
    trackPromise(
      getRoutesByFactoryID());
  }, [cropSupplyInput.factoryID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWAMENDEDLEAFDETAILSREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setCropSupplyInput({
      ...cropSupplyInput,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(cropSupplyInput.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routes = await services.getRoutesForDropDown(cropSupplyInput.factoryID);
    setRouteList(routes);
  }

  function refreshSearchData() {
    setAmendedLeafDetails([]);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }

  async function GetDetails() {
    let model = {
      groupID: parseInt(cropSupplyInput.groupID),
      factoryID: parseInt(cropSupplyInput.factoryID),
      routeID: parseInt(cropSupplyInput.routeID),
      registrationNumber: cropSupplyInput.registrationNumber,
      fromDate: moment(fromDate.toString()).format().split('T')[0],
      toDate: moment(toDate.toString()).format().split('T')[0],
    }

    getSelectedDropdownValuesForReport(model);

    const leafData = await services.GetAmendedLeafDetailsReport(model);
    if (leafData.statusCode == "Success" && leafData.data != null) {
      setAmendedLeafDetails(leafData.data);
      calTotal(leafData.data);
    }
    else {
      alert.error("No records to display");
    }
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setCropSupplyInput({
      ...cropSupplyInput,
      [e.target.name]: value
    });
    setCropSupplyDetails([]);
    refreshSearchData();
  }

  async function createDataForExcel(array) {
    var res = [];
    if (array != null) {
      array.map(x => {
        var vr = {
          Route: x.routeName,
          RegistrationNumber: x.registrationNumber,
          Name: x.name,
          CollectedDate: x.collectedDate.toString().split('T')[0],
          OriginalWeight: x.originalWeight,
          AmendedWeight: x.amendedWeight
        }
        res.push(vr);
      });
      var vr = {
        Route: "Total",
        RouteCode: "",
        OriginalWeight: amendedLeafTotal.originalWeight,
        AmendedWeight: amendedLeafTotal.amendedWeight
      }
      res.push(vr);

      res.push({});

      var vr = {
        'Route': 'Group Name :' + selectedSearchValues.groupName,
        'RegistrationNumber': 'Factory Name :' + selectedSearchValues.factoryName,
      }
      
      res.push(vr);
      var vr = {
        'Route': selectedSearchValues.routeName ? 'Route :'+ selectedSearchValues.routeName : 'Route :' + 'All Routes',
        'RegistrationNumber': 'Date : ' + moment(selectedSearchValues.selectedDate).format('DD/MM/YYYY')
      }
      res.push(vr);

    }
    return res;
  }

  async function createFile() {

    var file = await createDataForExcel(amendedLeafDetails);
    var settings = {
      sheetName: 'Amended Leaf Details Report',
      fileName: 'Amended Leaf Details Report' + selectedSearchValues.factoryName + ' - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.fromDate + ' to ' + selectedSearchValues.toDate,
      writeOptions: {}
    }

    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })

    let dataA = [
      {
        sheet: 'Amended Leaf Details Report',
        columns: tempcsvHeaders,
        content: file
      }
    ]

    xlsx(dataA, settings);
  }

    function calTotal(data) {
    let originalWeightSum = 0;
    let amendedWeightSum = 0;
    
    data.forEach(element => {
      originalWeightSum += parseFloat(element.originalWeight);
      amendedWeightSum += parseFloat(element.amendedWeight);
    });
    setAmendedLeafTotal({
      ...amendedLeafTotal,
      originalWeight: originalWeightSum,
      amendedWeight: amendedWeightSum,
    });

  }

  function getSelectedDropdownValuesForReport(searchForm) {
    var fromDate = moment(searchForm.fromDate.toString()).format().split('T')[0]
    var toDate = moment(searchForm.toDate.toString()).format().split('T')[0]
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[searchForm.groupID],
      factoryName: FactoryList[searchForm.factoryID],
      routeName: searchForm.routeID != 0 ? routeList[searchForm.routeID] : 'All Routes',
      fromDate: [fromDate],
      toDate: [toDate]
    })
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: cropSupplyInput.groupID,
              factoryID: cropSupplyInput.factoryID,
              fromDate: fromDate,
              toDate: toDate
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                fromDate: Yup.date().required('From Date is Required'),
                toDate: Yup.date().required('To Date is Required'),
              })
            }
            onSubmit={() => trackPromise(GetDetails())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={cropSupplyInput.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={cropSupplyInput.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField select
                              fullWidth
                              name="routeID"
                              onChange={(e) => handleChange(e)}
                              value={cropSupplyInput.routeID}
                              variant="outlined"
                              id="routeID"
                              size='small'
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routeList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="registrationNumber">
                              Registration Number
                            </InputLabel>
                            <TextField
                              fullWidth
                              name="registrationNumber"
                              onChange={(e) => handleChange(e)}
                              value={cropSupplyInput.registrationNumber}
                              variant="outlined"
                              id="registrationNumber"
                              size='small'
                            >
                            </TextField>
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>From Date *</InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                name='fromDate'
                                id='fromDate'
                                value={fromDate}
                                maxDate={new Date()}
                                onChange={(e) => {
                                  setfromDate(e)
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                autoOk
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>To Date *</InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                name='fromDate'
                                id='fromDate'
                                value={toDate}
                                onChange={(e) => {
                                  settoDate(e)
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                autoOk
                                maxDate={new Date()}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Box display="flex" flexDirection="row-reverse" p={2} >
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            size='small'>
                            Search
                          </Button>
                        </Box>
                      </CardContent>

                        <Box display="flex" minWidth={800} p={2}>
                          {amendedLeafDetails.length > 0 ? 
                            <TableContainer component={Paper} >
                                <Table aria-label="caption table">
                                <TableHead>
                                    <TableRow>
                                    <TableCell align={'center'} style={{border: "1px solid black"}}>Route</TableCell>
                                    <TableCell align={'center'} style={{border: "1px solid black"}}>registration Number</TableCell>
                                    <TableCell align={'center'} style={{border: "1px solid black"}}>Name</TableCell>
                                    <TableCell align={'center'} style={{border: "1px solid black"}}>Collected Date</TableCell> 
                                    <TableCell align={'center'} style={{border: "1px solid black"}}>Original Weight</TableCell>
                                    <TableCell align={'center'} style={{border: "1px solid black"}}>Amended Weight</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                  {amendedLeafDetails.slice(page * limit, page * limit + limit).map((group, index) => (
                                    <React.Fragment key={index}>
                                        <TableRow>
                                            <TableCell align={'left'} component="th" scope="row" style={{border: "1px solid black"}}>
                                              {group.routeName}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{border: "1px solid black"}}>
                                              {group.registrationNumber}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{border: "1px solid black"}}>
                                              {group.name}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{border: "1px solid black"}}>
                                              {moment(group.collectedDate).format('YYYY-MM-DD')}
                                            </TableCell> 
                                            <TableCell align={'right'} component="th" scope="row" style={{border: "1px solid black"}}>
                                              {group.originalWeight}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{border: "1px solid black"}}>
                                              {group.amendedWeight }
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                    ))
                                    }
                                </TableBody>
                                <TableFooter>
                                        <TableRow>
                                            <TableCell colSpan={4} style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px' }} align={'center'}><b>Total</b></TableCell>
                                            <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px' }} >
                                              {Number(amendedLeafTotal.originalWeight).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                            <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px' }} >
                                              {Number(amendedLeafTotal.amendedWeight).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                        </TableRow>
                                </TableFooter>
                                </Table>
                                <TablePagination 
                                    component="div"
                                    count={amendedLeafDetails.length}
                                    page={page}
                                    onChangePage={handlePageChange}
                                    rowsPerPage={limit}
                                    onChangeRowsPerPage={handleLimitChange}
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                />
                            </TableContainer>  
                      : null}
                      </Box>

                      {amendedLeafDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={createFile}
                          >
                            EXCEL
                          </Button>
                          <div>&nbsp;</div>
                          <ReactToPrint
                            documentTitle={"Amended Leaf Details Report"+ ' - ' + selectedSearchValues.factoryName + ' - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.fromDate + ' to ' + selectedSearchValues.toDate}
                            trigger={() => <Button
                              color="primary"
                              id="btnCancel"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                            >
                              PDF
                            </Button>}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                          <CreatePDF 
                              ref={componentRef} 
                              amendedLeafDetails={amendedLeafDetails} 
                              amendedLeafTotal={amendedLeafTotal}
                              searchData={selectedSearchValues} />
                          </div>
                        </Box>: null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
